<template>
  <div class="animated fadeIn">
    <button
    type="button"
      @click="OpenModal"
      class="btn btn-danger mr-2"
      title="Remove este GAAU"
    >
      Excluir
    </button>
    <b-modal
      v-model="modal"
      title="Confirmar exclusão"
      class="modal-danger"
      ok-variant="danger"
      @ok="ModalOk"
    >
      Você confirma a exclusão desse registro?
    </b-modal>
  </div>
</template>
    
    <script>
import RotateSquare from "../../components/RotateSquare";
import GaauService from "../../servico/GaauService";

export default {
  name: "RemoveGaauButton",
  components: {
    RotateSquare,
    GaauService
  },
  props: {
    gaauId: {
      type: String,
      default: ""
    },
    version: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      modal: false,
    };
  },

  mounted() {
    this.modal = false;
  },
  methods: {
    OpenModal() {
      this.modal = true;
    },
    ModalOk() {
      this.loading = true;

      GaauService.Remove(this.gaauId, this.version)
        .then((response) => {
          this.loading = false;
          this.$notify({
            data: ["GAAU removido com sucesso."],
            type: "success",
            duration: 5000
          });
          this.$router.go(-1);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },

  }
};
</script>
    